(function () {
  var cart_attribute_name = '_as_cc_g__';
  var proceed_choice = 'proceed';
  var decline_choice = 'decline';

  function start(provider_callback) {
    var section = document.querySelector('[data-geo-access-popup]');

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var config = get_config(section);

    if (!config) {
      return;
    }

    var saved_choice = get_cookie(config.cookie_name);

    if (saved_choice === proceed_choice) {
      return;
    }

    if (saved_choice === decline_choice) {
      handle_decline(config);
      return;
    }

    provider_callback(config, function (country_code) {
      handle_country_code(config, country_code);
    });
  }

  function get_config(section) {
    var config_id = section.getAttribute('data-config-id');
    var config_element = document.getElementById(config_id);

    if (!config_element) {
      return null;
    }

    try {
      var config = JSON.parse(config_element.textContent);

      config.allowed_country_code = clean_country_code(config.allowed_country_code || 'AU');
      config.cookie_name = config.cookie_name || '_as_cc_g';
      config.remember_days = Number(config.remember_days) || 1;
      config.heading = config.heading || 'Looks like you are outside Australia';
      config.message = config.message || 'This website is intended for visitors in Australia.';
      config.proceed_label = config.proceed_label || 'Proceed';
      config.decline_label = config.decline_label || 'Do not proceed';
      config.decline_message = config.decline_message || 'You have chosen not to continue.';
      config.decline_action = config.decline_action || 'message';
      config.decline_redirect_url = config.decline_redirect_url || '';

      return config;
    } catch (error) {
      return null;
    }
  }

  function handle_country_code(config, country_code) {
    var clean_code = clean_country_code(country_code);

    if (!clean_code) {
      return;
    }

    if (clean_code !== config.allowed_country_code) {
      show_popup(config, clean_code);
    }
  }

  function clean_country_code(country_code) {
    return String(country_code || '').trim().toUpperCase();
  }

  function show_popup(config, country_code) {
    if (document.querySelector('.geo-access-popup')) {
      return;
    }

    document.documentElement.classList.add('geo-access-popup-open');
    document.body.classList.add('geo-access-popup-open');

    var overlay = document.createElement('div');
    overlay.className = 'geo-access-popup';
    overlay.setAttribute('role', 'presentation');

    var dialog = document.createElement('div');
    dialog.className = 'geo-access-popup__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'GeoAccessPopupHeading');
    dialog.setAttribute('aria-describedby', 'GeoAccessPopupMessage');

    var heading = document.createElement('h2');
    heading.className = 'geo-access-popup__heading';
    heading.id = 'GeoAccessPopupHeading';
    heading.textContent = config.heading;

    var message = document.createElement('p');
    message.className = 'geo-access-popup__message';
    message.id = 'GeoAccessPopupMessage';
    message.textContent = config.message;

    var actions = document.createElement('div');
    actions.className = 'geo-access-popup__actions';

    var proceed_button = document.createElement('button');
    proceed_button.className = 'geo-access-popup__button geo-access-popup__button--primary';
    proceed_button.type = 'button';
    proceed_button.textContent = config.proceed_label;

    var decline_button = document.createElement('button');
    decline_button.className = 'geo-access-popup__button geo-access-popup__button--secondary';
    decline_button.type = 'button';
    decline_button.textContent = config.decline_label;

    proceed_button.addEventListener('click', function () {
      set_cookie(config.cookie_name, proceed_choice, config.remember_days);
      save_cart_attribute(proceed_choice, country_code);
      document.documentElement.classList.remove('geo-access-popup-open');
      document.body.classList.remove('geo-access-popup-open');
      overlay.remove();
    });

    decline_button.addEventListener('click', function () {
      set_cookie(config.cookie_name, decline_choice, config.remember_days);
      save_cart_attribute(decline_choice, country_code);
      handle_decline(config);
    });

    actions.appendChild(proceed_button);
    actions.appendChild(decline_button);
    dialog.appendChild(heading);
    dialog.appendChild(message);
    dialog.appendChild(actions);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    proceed_button.focus();
  }

  function handle_decline(config) {
    if (should_redirect_decline(config)) {
      window.location.href = config.decline_redirect_url;
      return;
    }

    show_decline_popup(config);
  }

  function should_redirect_decline(config) {
    if (config.decline_action !== 'redirect' || !config.decline_redirect_url) {
      return false;
    }

    try {
      var redirect_url = new URL(config.decline_redirect_url, window.location.origin);

      return redirect_url.href !== window.location.href;
    } catch (error) {
      return false;
    }
  }

  function show_decline_popup(config) {
    var existing_popup = document.querySelector('.geo-access-popup');
    var overlay = existing_popup || document.createElement('div');

    overlay.className = 'geo-access-popup';
    overlay.setAttribute('role', 'presentation');
    overlay.innerHTML = '';

    document.documentElement.classList.add('geo-access-popup-open');
    document.body.classList.add('geo-access-popup-open');

    var dialog = document.createElement('div');
    dialog.className = 'geo-access-popup__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'GeoAccessDeclineHeading');
    dialog.setAttribute('aria-describedby', 'GeoAccessDeclineMessage');

    var heading = document.createElement('h2');
    heading.className = 'geo-access-popup__heading';
    heading.id = 'GeoAccessDeclineHeading';
    heading.textContent = config.heading;

    var message = document.createElement('p');
    message.className = 'geo-access-popup__message';
    message.id = 'GeoAccessDeclineMessage';
    message.textContent = config.decline_message;

    dialog.appendChild(heading);
    dialog.appendChild(message);
    overlay.appendChild(dialog);

    if (!existing_popup) {
      document.body.appendChild(overlay);
    }
  }

  function get_cookie(name) {
    var cookie_name = encodeURIComponent(name) + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(cookie_name) === 0) {
        return decodeURIComponent(cookie.substring(cookie_name.length));
      }
    }

    return '';
  }

  function set_cookie(name, value, days) {
    var max_age = Math.max(Number(days) || 1, 1) * 24 * 60 * 60;
    var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    cookie += '; path=/';
    cookie += '; max-age=' + max_age;
    cookie += '; SameSite=Lax';

    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }

    document.cookie = cookie;
  }

  function save_cart_attribute(choice, country_code) {
    var cart_update_url = '/cart/update.js';
    var attribute_value = choice + ':' + clean_country_code(country_code);
    var body = {
      attributes: {},
    };

    if (window.routes && window.routes.cart_update_url) {
      cart_update_url = window.routes.cart_update_url;
    }

    body.attributes[cart_attribute_name] = attribute_value;

    fetch(cart_update_url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }).catch(function () {
      return;
    });
  }

  window.geo_access_popup = {
    start: start,
  };
})();
